// API for the monthly feedback check-in: the popup every signed-in user gets
// (components/Other/FeedbackCheckIn.js) and the Monthly Feedback page
// (Admin / IT). Server: server/routes/api/Feedback/feedbackCheckinHandler.js.
// Every call identifies the caller by the x-user-id header.

export const FEEDBACK_ROLES = ["Admin", "IT"];

const request = async (url, userId, { method = "GET", body } = {}) => {
  const res = await fetch(url, {
    method,
    headers: {
      Accept: "application/json",
      "x-user-id": userId || "",
      ...(body ? { "Content-Type": "application/json" } : {}),
    },
    body: body ? JSON.stringify(body) : undefined,
  });
  let content = {};
  try {
    content = await res.json();
  } catch (e) {
    // Non-JSON error page (e.g. the server is restarting).
  }
  if (!res.ok) throw new Error(content.error || "Request failed");
  return content;
};

// → { due, nextPromptAt, intervalDays }
export const fetchCheckInStatus = (userId) =>
  request("/api/feedback-checkin/status", userId);

// Either one starts the next wait. → { nextPromptAt }
export const sendFeedback = (userId, message, page) =>
  request("/api/feedback-checkin/respond", userId, {
    method: "POST",
    body: { action: "send", message, page },
  });

export const dismissCheckIn = (userId) =>
  request("/api/feedback-checkin/respond", userId, {
    method: "POST",
    body: { action: "dismiss" },
  });

// ---- Monthly Feedback page ----

// → { intervalDays, totals, latest, people }
export const fetchFeedbackOverview = (userId) =>
  request("/api/feedback-checkin/admin", userId);

// `before` = the last row's `at`, for the next page. → { responses, hasMore }
export const fetchFeedbackResponses = (userId, { q = "", before } = {}) => {
  const params = new URLSearchParams();
  if (q.trim()) params.set("q", q.trim());
  if (before) params.set("before", before);
  return request(`/api/feedback-checkin/admin/responses?${params}`, userId);
};

export const askAgain = (userId, personId) =>
  request(
    `/api/feedback-checkin/admin/people/${encodeURIComponent(personId)}/ask-again`,
    userId,
    { method: "POST" }
  );
